<ng-container *ngFor="let switchItem of tabSwitchItems$ | async; trackBy: trackBySwitchItemId">
    <div 
        class="switch-item" 
        [ngClass]="{
            'active': (selectedItemId$ | async) === switchItem.id
        }"
        (click)="changeSelectedItem(switchItem.id)"
    >
        <span class="title">{{switchItem.title}}</span>
        <span *ngIf="switchItem.subtitle" class="subtitle">{{switchItem.subtitle}}</span>
    </div>
</ng-container>
